module.exports = __webpack_public_path__ + "img/weixin1.dc43dc6c.jpeg";